export const decoratePopUpMessage = (text: string) => {
  if (!text) {
    return ''
  }

  let decoratedText = text;

  if (text[text.length - 1] === '.') {
    decoratedText = decoratedText.substr(0, decoratedText.length - 1);
  }

  // if (decoratedText.indexOf('username') !== -1) {
  //   decoratedText = decoratedText.replace('username', 'email')
  // }

  return decoratedText;
};
